/* eslint-disable */
<template>
  <div class="impacts-selectors">
    <div class="impacts-header">
      <h2>Impacts</h2>
      <div class="impacts-controls-wrapper">
        <div class="control-row">
          <span class="control-label" id="selector-type-label">Period</span>
          <a-select
            v-model:value="selectorType"
            style="min-width:160px"
            aria-labelledby="selector-type-label"
          >
            <a-select-option value="month">Single month</a-select-option>
            <a-select-option value="multi">Multi-month</a-select-option>
            <a-select-option value="year">Year</a-select-option>
          </a-select>

          <template v-if="selectorType === 'month'">
            <span class="control-label" id="month-label">Month</span>
            <a-select
              v-model:value="month"
              style="min-width:160px"
              aria-labelledby="month-label"
            >
              <a-select-option v-for="m in months" :key="m.value" :value="m.value">
                {{ m.label }}
              </a-select-option>
            </a-select>

            <span class="control-label" id="year-label">Year</span>
            <a-select
              v-model:value="year"
              style="min-width:160px"
              aria-labelledby="year-label"
            >
              <a-select-option v-for="y in years" :key="y" :value="y">{{ y }}</a-select-option>
            </a-select>
          </template>

          <template v-if="selectorType === 'multi'">
            <span class="control-label" id="multi-months-label">Months</span>
            <a-select
              mode="multiple"
              v-model:value="multiMonths"
              style="min-width:200px"
              aria-labelledby="multi-months-label"
            >
              <a-select-option v-for="m in months" :key="m.value" :value="m.value">
                {{ m.label }}
              </a-select-option>
            </a-select>

            <span class="control-label" id="year-multi-label">Year</span>
            <a-select
              v-model:value="year"
              style="min-width:160px"
              aria-labelledby="year-multi-label"
            >
              <a-select-option v-for="y in years" :key="y" :value="y">{{ y }}</a-select-option>
            </a-select>
          </template>

          <template v-if="selectorType === 'year'">
            <span class="control-label" id="year-only-label">Year</span>
            <a-select
              v-model:value="year"
              style="min-width:160px"
              aria-labelledby="year-only-label"
            >
              <a-select-option v-for="y in years" :key="y" :value="y">{{ y }}</a-select-option>
            </a-select>
          </template>
        </div>
      </div>
    </div>
    <!-- 5-column image + caption block -->
    <div class="five-cols">
      <div class="col" v-for="(src, i) in images" :key="i">
        <div class="caption"><h3 :style="{ color: captionsColors[i] }">{{ imageCaptions[i] }}</h3></div>
        <img :src="src" :alt="`Image ${i+1}`" />
        <div class="caption">
          <template v-if="impactsLoading">
            <a-spin  />
          </template>
          <template v-else>
            <h3 :style="{ color: captionsColors[i] }">{{ percentages[i] ?? '--' }}</h3>
            <h3 :style="{ color: captionsColors[i] }">{{ legends[i] ?? '--' }}</h3>
          </template>
        </div>
      </div>
    </div>
    <StatsImpacts :start_date="start_date" :end_date="end_date" :key="start_date.join(',')+ ',' +end_date.join(',')" />
    <StatsImpacts2 :start_date="start_date" :end_date="end_date" :key="start_date.join(',')+ ',,' +end_date.join(',')" />
    </div>
</template>

<script>
/* eslint-disable */
import { ref, computed, watch } from 'vue'
import { Select, Spin } from 'ant-design-vue'
import img1 from '@/assets/images/1.png'
import img2 from '@/assets/images/2.png'
import img3 from '@/assets/images/3.png'
import img4 from '@/assets/images/4.png'
import img5 from '@/assets/images/5.png'
import StatsImpacts from '@/services/queries/stats/StatsImpacts.vue';
import StatsImpacts2 from '@/services/queries/stats/StatsImpacts2.vue';
import { useStore } from 'vuex'

export default {
  name: 'ImpactsSelectors',
  components: {
    ASelect: Select,
    ASelectOption: Select.Option,
    ASpin: Spin,
    StatsImpacts,
    StatsImpacts2
  },
  emits: ['update:selection'],
  setup (props, { emit }) {
    const selectorType = ref('month')
    const store = useStore();

    const months = [
      { value: 1,  label: 'January'   },
      { value: 2,  label: 'February'  },
      { value: 3,  label: 'March'     },
      { value: 4,  label: 'April'     },
      { value: 5,  label: 'May'       },
      { value: 6,  label: 'June'      },
      { value: 7,  label: 'July'      },
      { value: 8,  label: 'August'    },
      { value: 9,  label: 'September' },
      { value: 10, label: 'October'   },
      { value: 11, label: 'November'  },
      { value: 12, label: 'December'  }
    ]

    const now         = new Date()
    const month       = ref(now.getMonth() + 1)
    const multiMonths = ref([month.value])
    const year        = ref(now.getFullYear())

    const years = computed(() => {
      const current = new Date().getFullYear()
      const range = []
      for (let i = 0; i < 6; i++) range.push(current - i)
      return range
    })

    // example image sources (imported so bundler includes them)
    const images = [
      img4,
      img1,
      img3,
      img5,
      img2
    ]
    const imageCaptions = [
      'Single-Occupant Vehicle',
      'Alternative transportation',
      'Reduced carbon emissions',
      'Reduced Vehicle miles travelled',
      'Commute Cost Savings'
    ];


    const captionsColors = [
      '#FF6B6B', // red
      '#1BAC5D', // teal
      '#181818', // gray-blue
      '#2370C6', // lime green
      '#72AD44'  // yellow-orange
    ];

    // helpers to produce YYYY-MM-DD
    const pad = (n) => String(n).padStart(2, '0')
    const toYMD = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`

    const computeRange = () => {
      const y = year.value
      if (selectorType.value === 'year') {
        const s = toYMD(y, 1, 1)
        const e = toYMD(y, 12, 31)
        return { start: [s], end: [e] } // return arrays with single element
      }
      if (selectorType.value === 'month') {
        const m = month.value
        const last = new Date(y, m, 0).getDate()
        return { start: [toYMD(y, m, 1)], end: [toYMD(y, m, last)] } // single-element arrays
      }
      // multi-month: return arrays of start/end for each selected month
      const monthsArr = (multiMonths.value && multiMonths.value.length) ? multiMonths.value.slice().sort((a, b) => a - b) : [month.value]
      const starts = monthsArr.map(m => toYMD(y, m, 1))
      const ends = monthsArr.map(m => {
        const last = new Date(y, m, 0).getDate()
        return toYMD(y, m, last)
      })
      return { start: starts, end: ends }
    }

    const start_date = computed(() => computeRange().start)
    const end_date   = computed(() => computeRange().end)

    // watch and emit selection
    watch([selectorType, month, multiMonths, year], () => {
      emit('update:selection', {
        type:       selectorType.value,
        month:      month.value,
        months:     multiMonths.value.slice().sort((a, b) => a - b),
        year:       year.value,
        start_date: start_date.value,
        end_date:   end_date.value
      })
    }, { immediate: true })

    // use same query hook as StatsImpacts to obtain loading state
    // pass initial values; the underlying vue-query cache shares state by key in stats.api
    const impactsQuery = computed(() => store.state.stats.commuterImpactsStatsQuery);
    const impactsQuery2 = computed(() => store.state.stats.commuterImpacts2StatsQuery);

    const impactsLoading = computed(() => impactsQuery.value?.isLoading || impactsQuery2.value?.isLoading);

    const impactsQueryData = computed(() => impactsQuery.value?.data || {});
    const impactsQuery2Data = computed(() => impactsQuery2.value?.data || {});

    // merge percentages from both queries into a single ordered array
    const percentages = computed(() => {
      const q1 = impactsQueryData.value || {};
      const q2 = impactsQuery2Data.value || {};

      const values = [
        q1.single_occupant_vehicles_percentage,
        q1.alternative_transportation_percentage,
        q1.total_carbon_saved_percentage,
        q2.total_vehicle_miles_percentage_saved,
        q2.total_commuter_cost_percentage
      ];

      return values.map(v => {
        if (v == null) return null;
        const num = Number(v);
        if (!Number.isFinite(num)) return null;
        // format with one decimal if not integer
        return (num % 1 === 0) ? `${num}%` : `${num.toFixed(1)}%`;
      });
    });

    const legends = computed(() => {
      const q1 = impactsQueryData.value || {};
      const q2 = impactsQuery2Data.value || {};

      const values = [
        `( ${q1.single_occupant_vehicles} logged trips)`,
        `( ${q1.alternative_transportation} logged trips)`,
        `( ${q1.total_carbon_saved?.toFixed(2) ?? 0} Kg less CO2)`,
        `( ${q2.total_vehicle_miles?.toFixed(2) ?? 0} less miles)`,
        `( ${(q2.total_commuter_savings + q2.total_commuter_incentives)?.toFixed(2) ?? 0} commute savings)`,
      ];

      return values;
    });


    console.log('ImpactsSelectors - impactsQueryData:', impactsQueryData.value);
    console.log('ImpactsSelectors - impactsQuery2Data:', impactsQuery2Data.value);
    return { selectorType, months, month, multiMonths, year, years, start_date, end_date, images, imageCaptions, captionsColors, impactsLoading, percentages, legends }
  }
}
</script>

<style scoped>
.impacts-selectors {
  width: 100%;
}

.impacts-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.impacts-header h2 {
  margin: 0;
  white-space: nowrap;
}

.impacts-controls-wrapper {
  display: flex;
  align-items: center;
}

.control-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.control-label {
  font-weight: 500;
  white-space: nowrap;
}

.current-selection {
  margin-top: 16px;
}

/* styles for 5-column image grid */
.five-cols {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-top: 16px;
  align-items: start;
}

/* center content inside each column and stack caption below */
.five-cols .col {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* make images square and smaller */
.five-cols img {
  width: 172px;            /* desired square size */
  height: 172px;           /* match width to keep square */
  border-radius: 6px;
  display: block;
  object-fit: cover;       /* keep aspect ratio, crop if needed instead of stretching */
  object-position: center; /* center the image within the box */
}

/* caption spacing and style */
.five-cols .caption {
  margin-top: 8px;
  font-size: 14px;
  color: #333;
}

.five-cols .col:nth-child(2) img {
  width: 250px;
  height: 172px;
}
</style>
